
import { steps } from '../data/steps.module'
import '../App.css';
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { SetStateAction } from 'react';
import { setTextRange } from 'typescript';


export default function MobileSteps () {


        const location = useLocation();
    
        let homeClass = "" ;
        let verifyclass = "";
        let personalinfo = "";
        let address = "";
        let payment = "";
    
        
        if (location.pathname=="/personal-lookup" || location.pathname=="/personal-lookup-verify")
        {   
            verifyclass = "list-group-item active";
            personalinfo ="list-group-item";
            address ="list-group-item";
            payment ="list-group-item";
    
        } else if (location.pathname=="/personal-info")
        {   
            verifyclass = "list-group-item active";
            personalinfo ="list-group-item active";
            address ="list-group-item";
            payment ="list-group-item";
    
        } else if (location.pathname=="/address")
        {   

            verifyclass = "list-group-item active";
            personalinfo ="list-group-item completed";
            address ="list-group-item active";
            payment ="list-group-item";
    
        } else if (location.pathname=="/payment")
        {   

            verifyclass = "list-group-item active";
            personalinfo ="list-group-item active";
            address ="list-group-item active";
            payment ="list-group-item";
    
        } else {

            verifyclass = "list-group-item";
            personalinfo ="list-group-item";
            address ="list-group-item";
            payment ="list-group-item";
        }
       
    
    return (
        <div className='sidebar_mobile'>
            
            <div className="col-12 mx-auto">
            <div className="col-12 col-sm-12">
                <ul className="list-group list-group-horizontal">
                
                    <li className={verifyclass} key="2">
                        Personal Info
                    </li>
                    <li className={address} key="3">
                        Address
                    </li>
                    <li className={payment} key="4">
                       Review & Pay
                    </li>
                    </ul>
                </div>
            </div>
            </div>
            
    )
}